
import { PropTypes } from 'prop-types';
import Accordion from '../../campusLife/accordion';

const ShowAccordion = ({ title, accordion, setAccordion }) => {
    return (
        <div className="grid gap-8 w-full">
            <h1 className="text-4xl font-bold ">{title}</h1>
            <Accordion accordion={accordion} setAccordion={setAccordion} />
        </div>
    )
}
ShowAccordion.propTypes = {
    title: PropTypes.string,
    accordion: PropTypes.array,
    setAccordion: PropTypes.func
}
export default ShowAccordion